import { AppRouteProps } from "@harea/component";
import React from "react";

const FamilyUserDetailsContainer = React.lazy(() => import('./containers/FamilyUserDetailsContainer'))
export const FamilyUserDetailsRoutes: Array<AppRouteProps> = [
    {
        path: 'family',
        title: '{{FamilyMembersTab}}',
        element: <FamilyUserDetailsContainer />
    }
]
